export default __webpack_public_path__ + "static/media/p1_optimal_mockup.c40a930d.png";